<template>
  <div class="vx-col w-full lg:w-1/3 sm:w-full mb-base">
    <vx-card>
      <span class="title-head">ชำระเงินแบบกำหนดเอง</span><br><br>
      <div class="vx-row flex">
        <span class="vx-col flex-1 text-left label">ระบุจำนวนเงิน</span>
      </div><br>
      <div class="vx-row flex">
        <div class="vx-col w-full">
          <vx-input-group class="mb-6">
            <template slot="append">
              <div class="append-text bg-primary">
                <span>บาท</span>
              </div>
            </template>
            <vs-input type="number" v-model="amount" />
          </vx-input-group>
        </div>
      </div>
      <vs-button type="filled" class="w-full" color="primary" :disabled="disabledSubmit" @click="btnQrPayment('custom', amount)">ชำระเงิน</vs-button>
    </vx-card >
  </div>
</template>

<script>

const moment = require('moment');
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapAccountingState } = createNamespacedHelpers('Accounting')

export default {
  name: "PaymentCustom",
  data () {
    return {
      amount: 0,
    }
  },
  props: {
    btnQrPayment: Function,
  },
  computed: {
    ...mapAccountingState(['status', 'paymentAmountDetailNormal', 'paymentAmountDetailOutstanding', 'paymentRoundDetail', 'contract', 'loan', 'qrPayment']),
    disabledSubmit() {
      if( this.amount < this.paymentAmount && !this.paymentCustom ) {  return true  }
      else if ( this.amount == 0 ){ return true }
      else { return false}
    },
    paymentRoundDate(){
      if(this.contract.loan && this.paymentRoundDetail){
        return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.paymentRoundDetail.paymentRoundDate).add(this.contract.loan.coDate, 'days').format("YYYY-MM-DD"))
      }else{
        return "-"
      }
    },
    lastPaymentRoundDate(){
      if(this.contract.loan && this.paymentRoundDetail){
        return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.paymentRoundDetail.lastPaymentRoundDate).add(this.contract.loan.coDate, 'days').format("YYYY-MM-DD"))
      }else{
        return "-"
      }
    },
  },
}
</script>

<style scoped>

</style>


